import { TagColor } from "../../../app/data/common/tagColor";

export const statusColor = (status: string): TagColor => {
  switch (status) {
    case "COMPLETED":
      return TagColor.GREEN;
    case "PENDING":
    case "CREATED":
      return TagColor.BLUE;
    case "FAILED":
      return TagColor.RED;
    default:
      return TagColor.GREY;
  }
};

export const formatPct = (n: number | undefined) =>
  n == null || Number.isNaN(n) ? "—" : `${n.toFixed(1)}%`;

export const formatDuration = (seconds: number | null | undefined) => {
  if (seconds == null || Number.isNaN(seconds)) return "—";
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${h}h ${m}m`;
};

export const PAYMENT_PROVIDER_OPTIONS = [
  { value: "", label: "All" },
  { value: "INTERPAYMENTS", label: "Interpayments" },
  { value: "AUTHORIZE_NET", label: "Authorize.Net" },
];

export const PAYMENT_STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: "COMPLETED", label: "Completed" },
  { value: "PENDING", label: "Pending" },
  { value: "FAILED", label: "Failed" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "EXPIRED", label: "Expired" },
  { value: "CREATED", label: "Created" },
];

export const HEALTH_WINDOW_OPTIONS = [
  { value: "6", label: "6 hours" },
  { value: "24", label: "24 hours" },
  { value: "72", label: "72 hours" },
  { value: "168", label: "168 hours" },
];
